
  import React, { Component } from 'react';
  import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
  import axios from 'axios';
  import swal from 'sweetalert';
  import './App.css';
  import Video from './Video.js';
  import Login from './Login.js';

   
class App extends Component {

    constructor() {
        super();

        this.state = {
            isAuthenticated: false,
            ssID: JSON.parse(sessionStorage.getItem('Fvge5hhP6i'))
        };
    }

    componentWillMount() {
        let Fvge5hhP6i = sessionStorage.getItem('Fvge5hhP6i') !== null ? JSON.parse(sessionStorage.getItem('Fvge5hhP6i')) : false;
        
        if (Fvge5hhP6i) {

            this.setState({
                isAuthenticated: true,
            })
        }
        
        window.addEventListener('beforeunload', (event) => {
            sessionStorage.setItem('Fvge5hhP6i', JSON.stringify(this.state.ssID))
        }, false); 
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', (event) => {
        }, false); 
    }

    login = (password) => {

        axios.post(process.env.REACT_APP_API_HOST + '/login', { password: password })
            .then((response) => {
                
                if (response.data === true) {
                    this.setState({
                        isAuthenticated: true
                    })
                    this.setSSID();
                    this.props.history.push('/video');
                } else {
                    swal('You have entered an incorrect password')
                }
            })
    }

    setSSID = () => {
        
        axios.get(process.env.REACT_APP_API_HOST + '/ssID')
            .then((response) => {
                this.setState({
                    ssID: response.data
                })
            })
        }

      render() {
          return (
              <div className="container">
                  <Switch>
                      <Route exact path='/' render={() => this.state.isAuthenticated === true 
                      ? <Redirect to={{pathname: '/video', state: {from: this.props.location}}} />
                      : <Login login={(password) => this.login(password)} />} />
                      <Route path='/video' render={() => <Video isAuthenticated={this.state.isAuthenticated} />} />
                  </Switch>
              </div>
          );
      }
  }
  
  export default withRouter(App);  



// WEBPACK FOOTER //
// ./src/App.js